import { Divider } from 'antd';
import ButtonIconGhostMedium from '../../../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import RightMenuDesign from '../../../../components/house/RightMenuDesign/RightMenuDesign';
import { Icon } from '../../../../components/icon/icon';
import './RightPaletteGlassDoorMenu.scss';
import CardMaterial from '../CardMaterial/CardMaterial';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGlasses } from '../../../../store/actions/texture.action';
import InfiniteScroll from 'react-infinite-scroll-component';
import { DesignerPageContext } from '../../DesignerPage';
import { useTranslation } from 'react-i18next';
import { openMessageError } from '../../../../components/common/Message/openMessageError';
import { getValueFromString } from '../../../../utils/data/getValue.utils';

const RightPaletteGlassDoorMenu = ({ open, onClose, title }) => {
  return (
    <>
      <RightMenuDesign
        open={open}
        classNames={{ root: 'top-84', content: 'flex flex-col !p-0 gap-0' }}
        header={
          <div className="flex self-stretch items-center justify-start gap-8">
            <ButtonIconGhostMedium
              icon={<Icon.ICArrowBack />}
              onClick={onClose}
            />
            <span className="text-title-large">{title}</span>
          </div>
        }
        content={open ? <RenderContent /> : null}
      />
    </>
  );
};

export default RightPaletteGlassDoorMenu;

const RenderContent = () => {
  const { t } = useTranslation();
  const { selectedModels, selectedModel, sceneManager } =
    useContext(DesignerPageContext);
  const [texture, setTexture] = useState();
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const { textures } = useSelector(state => state.texture);
  const { glasses } = useSelector(state => state.texture);

  const loadMoreData = async () => {
    if (loading) {
      return;
    }
    setLoading(true);
    const { offset, limit } = textures;
    try {
      dispatch(
        fetchGlasses({
          offset,
          limit,
          product_type: 'test',
        })
      ).then(action => {
        setLoading(false);
      });
    } catch (e) {
      openMessageError({ content: t('Failed to load data!') });
      setLoading(false);
    }
  };

  const handleClick = useCallback(
    async (item, func, applyToAll) => {
      if (item.image) {
        const textureController = sceneManager.textureController;
        const applyTexture = async ({
          module,
          texture = {
            textureId: item.id,
            textureCode: item.name,
            texturePrice: item.price,
            url: item.image,
          },
        }) => {
          return await textureController.changeGlass({
            module,
            textureType: 'map',
            texture,
          });
        };

        const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
        const moduleEntries = Array.from(modules?.entries());
        if (applyToAll && selectedModel) {
          const len = moduleEntries?.length;
          if (len) {
            for (let i = 0; i < len; i++) {
              const [key, value] = moduleEntries[i];
              const model = value.group;
              await applyTexture({
                module: value,
              });
            }
          }
        } else {
          const len = selectedModels.length;
          if (len) {
            for (let i = 0; i < len; i++) {
              const model = selectedModels[i];
              const [item, value] = moduleEntries.find(
                ([item, value]) => value.group.uuid === model.uuid
              );
              await applyTexture({ module: value });
            }
          }
        }

        await sceneManager.calculateTotalCost?.({});
        func();
        traverseGlass(selectedModel);
      } else {
        openMessageError({
          content: t('The texture has no data, please select another texture.'),
        });
      }
    },
    [sceneManager, selectedModel, selectedModels]
  );

  const traverseGlass = selectedModel => {
    const modules = sceneManager?.cabinetManager?.currentCabinet?.modules;
    if (modules && selectedModel) {
      const moduleEntries = Array.from(modules.entries());
      const module = moduleEntries?.find(
        ([item, value]) => value.group.uuid === selectedModel?.uuid
      );

      if (module) {
        const [item, value] = module;

        const doorGlass = value.textures.get('GLASS-PANEL');

        if (doorGlass) {
          setTexture({
            name: doorGlass.textureCode ?? t('Not selected'),
            src: doorGlass.textureUrl,
            textureId: doorGlass.textureId,
          });
          // setPaintColor(textureHau.paintColor);
        } else {
          setTexture();
          // setPaintColor();
        }
      }
    }
  };

  useEffect(() => {
    setLoading(true);
    dispatch(
      fetchGlasses({
        offset: 0,
        limit: 20,
        product_type: 'test',
      })
    ).then(action => {
      setLoading(false);
    });
  }, []);

  useEffect(() => {
    traverseGlass(selectedModel);
  }, [selectedModel]);

  return (
    <>
      <div
        key={4}
        className="flex flex-col p-8 items-start gap-16 grow self-stretch overflow-auto"
        style={{ backgroundColor: '#F7F7F7' }}
      >
        <div
          id="right-palete-hau-menu"
          // className="flex flex-col self-stretch grow overflow-scroll"
        >
          <InfiniteScroll
            dataLength={glasses.data.length}
            next={loadMoreData}
            hasMore={glasses.data.length < glasses.total}
            // loader={
            //   <Divider plain>
            //     <span className="text-label-medium">Đang tải</span>
            //   </Divider>
            // }
            endMessage={
              <Divider plain>
                <span className="text-label-medium">
                  {t('No new data available')}
                </span>
              </Divider>
            }
            scrollableTarget={'right-palete-hau-menu'}
            className="flex flex-row flex-wrap gap-2"
          >
            {glasses.data.map(item => {
              return (
                <CardMaterial
                  key={item.id}
                  item={{
                    ...item,
                    title: getValueFromString(item.name),
                    src: item.icon,
                    description: item.description,
                  }}
                  active={texture && item.id === texture?.textureId}
                  onClick={async (func, applyToAll) => {
                    handleClick(item, func, applyToAll);
                  }}
                />
              );
            })}
          </InfiniteScroll>
        </div>
      </div>
    </>
  );
};
